import React from 'react';
import Translations from './index';

const TranslationError = ({ error, backup = "Your option could not be updated. Please try again." }) => {
    switch (error?.message) {
        case 'No coverage option is available for the selected dependent.':
            return <Translations text="selection.dependent_coverage_unavailable" backup="No coverage option is available for the selected dependent." />;
        case 'No Coverage is unavailable for another dependent.':
            return <Translations text="selection.no_coverage_unavailable" backup="No Coverage is unavailable for another dependent." />;
        case 'Balance is insufficient!':
            return <Translations text="error.Balance is insufficient!_desc" backup="Looks like there's not enough funds in your wallet for this option. Try picking a different plan." />;
        default:
            return <Translations text="selection.option_update_error" backup={backup} />;
    }
};

export default TranslationError;
